import { cn } from "@/lib/utils";

interface CardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  className?: string;
  classNameContent?: string;
}

export default function Card({
  title,
  description,
  children,
  className,
  classNameContent,
}: CardProps) {
  return (
    <div
      className={cn(
        "bg-gradient-to-b from-white to-blue-50 border border-blue-100 rounded-3xl p-8 group",
        className
      )}
    >
      <div
        className={cn(
          "overflow-hidden relative h-[300px] flex justify-center [mask-image:linear-gradient(to_bottom,rgba(0,0,0,1)_50%,rgba(0,0,0,0)_100%)] [mask-repeat:no-repeat] [mask-size:100%_100%]",
          classNameContent
        )}
        style={{ minHeight: "300px" }}
      >
        {children}
      </div>

      <div className="flex flex-col gap-2">
        <h3 className="text-xl font-medium">{title}</h3>
        <p className="text-slate-700 text-base">{description}</p>
      </div>
    </div>
  );
}
